var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }